import actionTypes from 'registration/actions/action-types';
import * as api from 'registration/resources/registration.api';

export const INDEPENDENT_TYPE = 'independent';
export const CHAIN_HEAD_TYPE = 'chain_head';
export const CHAIN_SUBORDINATE_TYPE = 'chain_subordinate';
export const SUPER_CHAIN_TYPE = 'super_chain';
export const PROSPECTIVE_TYPE = 'prospective';

const canSelfRegister = (retailer, retailerType, checkPrimaryUser = false) => {
  const canSelfRegister = retailer && retailer.active && retailer.retailerType.toLocaleLowerCase() === retailerType;
  if (checkPrimaryUser) {
    return canSelfRegister && !retailer.hasPrimaryUser;
  }
  return canSelfRegister;
};

export const fetchRetailerDetailsRequest = () => ({
  type: actionTypes.REGISTRATION_FETCH_RETAILER_DETAILS_REQUEST,
  error: false,
});

export const fetchRetailerDetailsSuccess = (retailer) => ({
  type: actionTypes.REGISTRATION_FETCH_RETAILER_DETAILS_SUCCESS,
  retailer,
});

export const fetchRetailerDetailsFailure = () => ({
  type: actionTypes.REGISTRATION_FETCH_RETAILER_DETAILS_FAILURE,
  error: true,
});

export const fetchRetailerDetails =
  ({ retailerId, captchaToken }) =>
  async (dispatch) => {
    try {
      dispatch(fetchRetailerDetailsRequest());
      const retailer = await api.fetchRetailerDetails(retailerId, captchaToken);
      retailer.retailerId = retailerId;
      retailer.canSelfRegisterIndependent = canSelfRegister(retailer, INDEPENDENT_TYPE);
      retailer.canSelfRegisterSuperChain = canSelfRegister(retailer, SUPER_CHAIN_TYPE);
      retailer.canSelfRegisterChainHead = canSelfRegister(retailer, CHAIN_HEAD_TYPE, true);
      retailer.canSelfRegisterChainSubordinate = canSelfRegister(retailer, CHAIN_SUBORDINATE_TYPE, true);
      retailer.canSelfRegister =
        retailer.canSelfRegisterIndependent ||
        retailer.canSelfRegisterSuperChain ||
        retailer.canSelfRegisterChainHead ||
        retailer.canSelfRegisterChainSubordinate;
      dispatch(fetchRetailerDetailsSuccess(retailer));
    } catch (error) {
      console.error('FETCH_RETAILER_DETAILS_FAILURE', error);
      dispatch(fetchRetailerDetailsFailure());
    }
  };

export const setRetailerDetails = (retailer) => (dispatch) => {
  dispatch(fetchRetailerDetailsSuccess(retailer));
};

export const clearRetailerDetails = () => (dispatch) => {
  dispatch({
    type: actionTypes.REGISTRATION_CLEAR_RETAILER_DETAILS,
  });
};

export const updateRetailerDetails = (retailer) => (dispatch) => {
  dispatch({
    type: actionTypes.REGISTRATION_UPDATE_RETAILER_DETAILS,
    retailer,
  });
};



// WEBPACK FOOTER //
// ./src/modules/registration/actions/fetch-retailer-details.actions.js